<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form label-width="100px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="仓库：">
              <el-input  maxlength="100" v-model="fetchRecord.depotName" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="出库原因：">
              <el-input  maxlength="100" v-model="fetchRecord.fetchTypeName" :readonly="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="fetchRecord.states==0">
          <el-col :span="24">
            <el-form-item label="取件二维码：">
              <img :src="fetchRecord.imgUrl" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="仪器：" v-for="(item, index) in insLst" :key="index">
              <span>{{item.instrumentName}}，{{item.serialNumber}}，{{item.statesName}}</span>
              <!-- <el-input v-model="item.instrumentName" :readonly="true"></el-input> -->
              <el-button v-waves v-if="item.states==0" type="danger" size="small" round @click="deleteIns(item.id,index)">删除</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getFetchDetails, deleteDetail } from "@/api/fetchApi";
export default {
  props: ["fetchRecord"],
  data() {
    return {
      ruleForm: {
        depotId: "",
        fetchType: "",
        insId: [],
      },
      insLst: [],
    };
  },
  created() {
    this.depostInfo();
  },
  methods: {
    //获取仓库数据
    depostInfo() {
      let self = this;
      getFetchDetails(this.fetchRecord.id).then((res) => {
        console.log(res);
        if (res.code == "200") {
          self.insLst = res.data;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    deleteIns(detailId, index) {
      let self = this;
      this.$confirm("确定删除吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          deleteDetail(detailId).then((res) => {
            if (res.code === "200") {
              self.$message.success(res.msg || "删除成功！");
              self.insLst.splice(index, 1);
            } else {
              self.$message.error(res.msg || "修改失败！");
              self.$message.success("删除失败");
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang='less' scoped>
.addModel {
  .addfrom {
    margin: 0 30px;
    .el-row {
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
      /deep/.el-input {
        width: 80%;
      }
    }
  }
  .footer {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/fetch/components/showFetch.vue